import React, { useState } from 'react';
import {
  Box,
  Typography,
  Alert,
} from '@mui/material';
import StyledButton from '../../common/StyledButton';
import StyledTextField from '../../common/StyledTextField';

const UserRegistration = ({ onNext, initialData = {} }) => {
  const [formData, setFormData] = useState({
    firstName: initialData.firstName || '',
    lastName: initialData.lastName || '',
    email: initialData.email || '',
    password: '',
    confirmPassword: '',
  });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: name === 'email' ? value.toLowerCase() : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (formData.password.length < 8) {
      setError('Password must be at least 8 characters long');
      return;
    }

    if (!formData.firstName.trim() || !formData.lastName.trim()) {
      setError('First name and last name are required');
      return;
    }

    try {
      await onNext({
        firstName: formData.firstName.trim(),
        lastName: formData.lastName.trim(),
        // Final guard against autofill/paste bypassing the onChange
        // lowercaser. Backend also normalizes, but doing it here keeps the
        // value consistent if we later display it before the round-trip.
        email: (formData.email || '').trim().toLowerCase(),
        password: formData.password
      });
    } catch (err) {
      setError(err.message || 'An error occurred');
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <StyledTextField
        fullWidth
        label="First Name"
        name="firstName"
        value={formData.firstName}
        onChange={handleChange}
        required
        margin="normal"
      />

      <StyledTextField
        fullWidth
        label="Last Name"
        name="lastName"
        value={formData.lastName}
        onChange={handleChange}
        required
        margin="normal"
      />

      <StyledTextField
        fullWidth
        label="Email"
        name="email"
        type="email"
        value={formData.email}
        onChange={handleChange}
        required
        margin="normal"
      />

      <StyledTextField
        fullWidth
        label="Password"
        name="password"
        type="password"
        value={formData.password}
        onChange={handleChange}
        required
        margin="normal"
      />

      <StyledTextField
        fullWidth
        label="Confirm Password"
        name="confirmPassword"
        type="password"
        value={formData.confirmPassword}
        onChange={handleChange}
        required
        margin="normal"
      />

      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
        <StyledButton
          type="submit"
          variant="contained"
        >
          Next
        </StyledButton>
      </Box>
    </Box>
  );
};

export default UserRegistration; 